const orange0 = "FFAA33";
const yellow0 = "FFD733";
const yellowLight = "F9FF33";
const greenLight = "ADFF33";
const forestGreen = "0E9F4D";
const seaBlue = "02D1CE";
const lightBlue = "66CDFC";
const blue = "2B40F4";
const lila = "492BF4";
const purple = "7C2BF4";
const purpleLight = "B22BF4";
const pink = "FF8EE4";
const red = "F40007";
const darkRed = "940610";
const lightRed = "FA5421";
const brown = "79493F";
const brownYellow = "79663F";
const grey = "9B9B9A";
const lightblack = "3F3F37";
const white="FFFFFF"

export const allColors = [
    red,
    lightRed,
    orange0,
    yellow0,
    yellowLight,
    greenLight,
    forestGreen,
    seaBlue,
    lightBlue,
    blue,
    lila,
    purple,
    purpleLight,
    pink,
    darkRed,
    brown,
    brownYellow,
    grey,
    lightblack,
    white
];
